var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.07.862l8.118 8.152a.507.507 0 0 1 0 .715.503.503 0 0 1-.713 0L.356 1.578a.507.507 0 0 1 0-.716.503.503 0 0 1 .713 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.356 9.014L8.476.862a.503.503 0 0 1 .712 0 .507.507 0 0 1 0 .716L1.069 9.729a.503.503 0 0 1-.713 0 .507.507 0 0 1 0-.715z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6da34850f237b4c89d4704e2de09f193.svg";
export { ForwardRef as ReactComponent };